import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { SCAMP_API } from 'src/environments/environment'
import { CommandResult } from '../pages/domain/commandResult'
import { AccountService } from './account.service'

@Injectable({ providedIn: 'root' })
export class MaterialEntradaService {
  url = ''

  constructor(private http: HttpClient, private account: AccountService) {
    this.url = SCAMP_API.accountApiV1
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.url}/materiais-entrada/${id}`, {
      headers: this.account.composeHeaders(),
    })
  }

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}/materiais-entradas`, {
      headers: this.account.composeHeaders(),
    })
  }

  getMaterialEntradaPorPeriodo(parameters): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.url}/materiais-entrada/por-periodo/${parameters.dataInicial}/${parameters.dataFinal}`,
      {
        headers: this.account.composeHeaders(),
      },
    )
  }

  exportarToExcel(parameters): Observable<any> {
    return this.http.get<any>(
      `${this.url}/materiais-entrada/por-periodo/excel/${parameters.dataInicial}/${parameters.dataFinal}`,
      { headers: this.account.composeHeaders() },
    )
  }

  getByPartNumeroDocumento(numeroDocumento): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.url}/materiais-entrada/by-part-numero-documento/${numeroDocumento}`,
      { headers: this.account.composeHeaders() },
    )
  }

  save(model: any): Observable<CommandResult> {
    return this.http.post<CommandResult>(
      `${this.url}/materiais-entrada`,
      model,
      { headers: this.account.composeHeaders() },
    )
  }

  IsUniqueNumeroDocumento(
    numeroDocumento: string,
    id: number,
  ): Observable<boolean> {
    return this.http.post<boolean>(
      `${this.url}/materiais-entrada/isunique-numero-documento`,
      { numeroDocumento: numeroDocumento, id: id },
      { headers: this.account.composeHeaders() },
    )
  }

  delete(id: number): Observable<CommandResult> {
    return this.http.delete<CommandResult>(
      `${this.url}/materiais-entrada/${id}`,
      { headers: this.account.composeHeaders() },
    )
  }
}
